import { fetchMfaSetup } from '@actions/mfa';
import { getMfaFetchError, getMfaIsFetching, getMfaSetupKey } from '@selectors/mfa';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchMfaSetup = (shouldFetch = true) => {
    const dispatch = useDispatch();
    const isFetching = useSelector(getMfaIsFetching);
    const fetchError = useSelector(getMfaFetchError);
    const mfaSetupKey = useSelector(getMfaSetupKey);

    useEffect(() => {
        if (shouldFetch) {
            dispatch(fetchMfaSetup());
        }
    }, [dispatch, shouldFetch]);

    return { isFetching, fetchError, mfaSetupKey };
};

export default useFetchMfaSetup;
